import { FC, useEffect, useState } from 'react';

import { Box } from '@bonusly/design-system';

interface Leaf {
	id: number;
	left: number;
	animationDuration: number;
	animationDelay: number;
	size: number;
	emoji: string;
	rotation: number;
	swayAmount: number;
}

//const LEAF_EMOJIS = ['🍂', '🍁', '🎃', '🦇', '👻'];

export const FallingLeaves: FC = () => {
	const [leaves, setLeaves] = useState<Leaf[]>([]);

	useEffect(() => {
		// Generate a set of leaves
		const generateLeaves = () => {
			const newLeaves: Leaf[] = [];
			// Create 20 leaves total (with varied frequency for different emojis)
			for (let i = 0; i < 20; i++) {
				// Weight the emojis - more leaves, fewer pumpkins/bats/ghosts
				let emoji: string;
				const rand = Math.random();
				if (rand < 0.4) {
					emoji = '🍂'; // 40% autumn leaf
				} else if (rand < 0.7) {
					emoji = '🍁'; // 30% maple leaf
				} else if (rand < 0.85) {
					emoji = '🎃'; // 15% pumpkin
				} else if (rand < 0.95) {
					emoji = '🦇'; // 10% bat
				} else {
					emoji = '👻'; // 5% ghost
				}

				newLeaves.push({
					id: i,
					left: Math.random() * 100,
					animationDuration: 10 + Math.random() * 15, // 10-25 seconds
					animationDelay: Math.random() * 20, // Stagger start times
					size: 18 + Math.random() * 18, // 18-36px
					emoji,
					rotation: Math.random() * 360,
					swayAmount: 40 + Math.random() * 80, // 40-120px horizontal movement
				});
			}
			return newLeaves;
		};

		setLeaves(generateLeaves());
	}, []);

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			width="100vw"
			height="100vh"
			pointerEvents="none"
			zIndex={9999}
			overflow="hidden"
			opacity={0}
			animation="fadeIn 1s ease-in forwards"
			sx={{
				'@keyframes fadeIn': {
					from: { opacity: 0 },
					to: { opacity: 1 },
				},
			}}
		>
			{leaves.map((leaf) => (
				<Box
					key={leaf.id}
					position="absolute"
					top={-50}
					left={`${leaf.left}%`}
					fontSize={`${leaf.size}px`}
					opacity={0.7}
					style={{
						animation: `fall-${leaf.id} ${leaf.animationDuration}s linear ${leaf.animationDelay}s infinite`,
						transform: `rotate(${leaf.rotation}deg)`,
					}}
				>
					<style>
						{`
							@keyframes fall-${leaf.id} {
								0% {
									transform: translateY(-50px) translateX(0px) rotate(${leaf.rotation}deg);
								}
								25% {
									transform: translateY(25vh) translateX(${leaf.swayAmount}px) rotate(${leaf.rotation + 90}deg);
								}
								50% {
									transform: translateY(50vh) translateX(0px) rotate(${leaf.rotation + 180}deg);
								}
								75% {
									transform: translateY(75vh) translateX(-${leaf.swayAmount}px) rotate(${leaf.rotation + 270}deg);
								}
								100% {
									transform: translateY(100vh) translateX(0px) rotate(${leaf.rotation + 360}deg);
								}
							}
						`}
					</style>
					{leaf.emoji}
				</Box>
			))}
		</Box>
	);
};
